import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Transaction notification context enum
 * @description Notification contexts specific to transaction subjects
 */
export enum TransactionNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Transaction-specific contexts
	ACTIVE = 'active',
	CANCELLED = 'cancelled',
}
